import React from 'react';
import {useTranslation} from 'react-i18next';
import {ModalSheetProps} from 'components/common/ModalSheet/ModalSheet';
import {ButtonProps} from '@chekinapp/ui';
import {StyledLogoutModalSheet, StyledModalSheet} from './styled';

function LogoutModalSheet({isOpenModalSheet, handleCloseModal}: ModalSheetProps) {
  const {t} = useTranslation();

  const modalSheetButtons: ButtonProps[] = React.useMemo(() => {
    const primaryButton: ButtonProps = {
      children: t('ok'),
      onClick: handleCloseModal,
    };
    return [primaryButton];
  }, [handleCloseModal, t]);

  return (
    <StyledModalSheet
      isOpenModalSheet={isOpenModalSheet}
      handleCloseModal={handleCloseModal}
      title={t('you_ve_been_logged_out')}
      padding
    >
      <StyledLogoutModalSheet
        buttons={modalSheetButtons}
        text={t('logged_out_message')}
      />
    </StyledModalSheet>
  );
}

export {LogoutModalSheet};
